import {
  Badge,
  Banner,
  Container,
  Header,
  Layout,
  Level,
  LevelGroup,
  LevelItem,
  MainContent,
  ScaffoldCard,
  ScaffoldCards,
  Section,
  Text,
} from '@inmotionnow/momentum-components-react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import { useGetAccountsQuery } from '@/features/accounts/accountApi'

const AccountListView = (): JSX.Element => {
  const { t } = useTranslation()
  const { data: accounts, isLoading, isError } = useGetAccountsQuery()

  const statusLayout = (message: string) => (
    <Layout>
      <Header>
        <Banner title={t('ACCOUNTS')} />
      </Header>
      <MainContent>
        <Section>
          <Container size='lg'>
            <Text>{message}</Text>
          </Container>
        </Section>
      </MainContent>
    </Layout>
  )

  if (isLoading) return statusLayout(t('LOADING'))
  if (isError) return statusLayout(t('UNKNOWN_ERROR'))

  const accountList = accounts ?? []

  return (
    <Layout>
      <Header>
        <Banner title={t('ACCOUNTS')} />
      </Header>
      <MainContent>
        <Section>
          <Container size='lg'>
            <ScaffoldCards>
              {accountList.map(account => (
                <ScaffoldCard key={account.id} data-testid='account-row'>
                  <>
                    <Level>
                      <LevelGroup position='left'>
                        <LevelItem>
                          <Text textWeight='bold'>
                            <Link to={`/admin/account/details/${account.id}`}>
                              {account.display_name}
                            </Link>
                          </Text>
                        </LevelItem>
                      </LevelGroup>
                    </Level>
                    <Level>
                      <LevelGroup position='left'>
                        <LevelItem>
                          <Badge
                            text={account.keycloak_realm_id}
                            namedColor='tertiary'
                            icon='briefcase'
                          />
                        </LevelItem>
                        {account.contact_email && (
                          <LevelItem>
                            <Text size='sm' color='muted'>
                              {account.contact_email}
                            </Text>
                          </LevelItem>
                        )}
                      </LevelGroup>
                    </Level>
                    <Level>
                      <LevelGroup position='left'>
                        <LevelItem>
                          <Badge
                            text={
                              account.is_active ? t('ACTIVE') : t('DISABLED')
                            }
                            namedColor={account.is_active ? 'green' : 'red'}
                          />
                        </LevelItem>
                      </LevelGroup>
                    </Level>
                  </>
                </ScaffoldCard>
              ))}
            </ScaffoldCards>
          </Container>
        </Section>
      </MainContent>
    </Layout>
  )
}

export { AccountListView }
